import awaitPeerDependencies from '@ssr/registry';
import { loadEnv } from './load-env';

loadEnv();

const registryDependencies = ['react', 'react-dom', 'react-intl'];

const index = translations => {
    return awaitPeerDependencies(registryDependencies).then(
        ({ react: React, 'react-dom': ReactDom }) => {
            import(/* webpackChunkName: "app" */ '../../app')
                .then(App => {
                    const { __environment__, ...state } =
                        window.SSR_LISTING_STATE || {};
                    ReactDom.hydrate(
                        <App.Listing
                            state={state}
                            translations={translations}
                        />,
                        document.getElementById('fragment-listing'),
                        () => {
                            // css styles are not required anymore once the applications has hydrated
                            const tamagoshiSSRStyles = document.getElementById(
                                'tamagoshi-ssr-styles-listing',
                            );

                            if (tamagoshiSSRStyles !== null) {
                                tamagoshiSSRStyles.parentNode.removeChild(
                                    tamagoshiSSRStyles,
                                );
                            }
                        },
                    );
                })
                .catch(e => {
                    console.log(e); // eslint-disable-line no-console
                });
        },
    );
};

export { index };
